import { Badge, StatusBadge, Tag } from "@maeiz/ui";
import { DocPage, Section, Demo, SpecTable } from "../../components/DocChrome";

export function BadgesPage() {
    return (
        <DocPage
            title="Badges & Status"
            description="Unified status language. Panels must not invent arbitrary status colors."
        >
            <Section title="How it looks">
                <Demo className="flex flex-wrap gap-2">
                    <Badge>Neutral</Badge>
                    <Badge tone="primary">Primary</Badge>
                    <Badge tone="gold" dot>
                        Verified
                    </Badge>
                    <Badge tone="success">Success</Badge>
                    <Badge tone="warning">Warning</Badge>
                    <Badge tone="danger">Danger</Badge>
                    <Badge tone="info">Info</Badge>
                    <StatusBadge status="pending" />
                    <StatusBadge status="succeeded" />
                    <StatusBadge status="failed" />
                    <StatusBadge status="synced" />
                    <Tag onRemove={() => undefined}>Area: DHA</Tag>
                </Demo>
            </Section>
            <Section title="Domain map">
                <SpecTable
                    rows={[
                        ["pending / offline", "warning"],
                        ["active / succeeded / paid / synced", "success"],
                        ["failed", "danger"],
                        ["verified", "gold"],
                        ["draft / cancelled / closed", "neutral"],
                    ]}
                />
            </Section>
        </DocPage>
    );
}
